<template>
  <header class="va-navbar app-layout-navbar app-header-white">
      <div class="va-navbar__content d-flex flex-row justify-content-between align-items-center">
        <div class="va-navbar__left me-auto">
          <div class="left">
            <button class="justify-center d-flex" @click="goTo('/profile')" style="cursor:pointer;">
              <img src="@/assets/MainClarityLogoHeader.png" class="va-icon-vuestic app-header-logo" alt="main_logo">
            </button>
          </div>
        </div>
        <div class="va-navbar__right d-flex flex-row pr-5">
          <div class="app-navbar-actions app-navbar__actions md5 lg4">
            <button class="app-navbar-actions__item app-navbar-actions__item--profile" @click="goTo('/list-view-drawer/organisations')" style="cursor:pointer;">
              <i class="material-icons app-header-icon">location_city</i>
            </button>
            <button class="app-navbar-actions__item app-navbar-actions__item--profile" @click="goTo('/list-view-drawer/companies')" style="cursor:pointer;">
              <i class="material-icons app-header-icon">account_balance</i>
            </button>
            <button class="app-navbar-actions__item app-navbar-actions__item--profile" @click="goTo('/list-view-drawer/departments')" style="cursor:pointer;">
              <i class="material-icons app-header-icon">storefront</i>
            </button>
            <v-menu
              v-model="profileMenu"
              offset-y
            >
              <template #activator="{ props }">
                <button
                  class="app-navbar-actions__item app-navbar-actions__item--profile"
                  style="cursor:pointer;"
                  v-bind="props"
                >
                  <i class="material-icons app-header-icon">person</i>
              </button>
              </template>

              <v-card min-width="220">
                <v-list density="compact">
                  <v-list-item @click="goTo('/list-view-drawer/users')">
                    <v-list-item-title>Users</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="goTo('/list-view-drawer/users', true)">
                    <v-list-item-title>Profile</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <button class="app-navbar-actions__item app-navbar-actions__item--profile" @click="forceLogout" style="cursor:pointer;">
              <i class="material-icons app-header-icon">logout</i>
            </button>
          </div>
        </div>
      </div>
  </header>
</template>

<script setup>
import { useRouter , useRoute} from 'vue-router'
import { usePathController } from '../composables/usePathController'
import { useUserStore } from "../store/user"
import {ref} from "vue"
import {useLogger} from "@/composables/useLogger"
const {sendLog} = useLogger() 

const userStore = useUserStore()
const router = useRouter()
const { logoutCoordinator } = usePathController()
const forceLogout = () => {
  logoutCoordinator()
  router.replace('/login')
}

const profileMenu = ref(false)
const goTo = (path, toSelfProfile) => {
  sendLog("debug", "redirect_using_goTo", {isAuthenticated: !!userStore.userId})
  if(toSelfProfile) router.push({path, query:{edit: userStore.userId}})
  else router.push({path})
}

</script>

<style scoped>
/* White background for header */
.app-header-white {
  background: #ffffff !important;
  background-image: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Logo styling for white background */
.app-header-logo {
  width: 150px;
  height: auto;
  max-height: 80px;
  object-fit: contain;
}

/* Icon styling for white background */
.app-header-icon {
  color: #2c3e50 !important;
  opacity: 0.8 !important;
  transition: all 0.2s;
}

.app-header-icon:hover {
  color: #0071BC !important;
  opacity: 1 !important;
}

/* Ensure proper spacing */
.va-navbar__content {
  padding: 0.75rem 2rem;
}

@media (max-width: 768px) {
  .app-header-logo {
    width: 120px;
    max-height: 80px;
  }

  .va-navbar__content {
    padding: 0.5rem 1rem;
  }
}
</style>
